import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getImgUrl, getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import AddHub from "./AddHub";
import { responseNotification } from "../../utils/notify";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import LoaderFull from "../common/LoaderFull";

const HubsList = () => {
  const [confirmLoading, setConfirmLoading] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [hubOptions, setHubOptions] = useState({ loading: false, list: [] });
  const [key, setKey] = useState("");
  const [selectedHub, setSelectedHub] = useState(undefined);
  const [selectedHubForEdit, setSelectedHubForEdit] = useState(undefined);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [hubData, setHubData] = useState({
    loading: false,
    data: null,
  });

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const getHub = useCallback(async () => {
    setHubData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/hub/all?page=${page || 0}&limit=${limit || 16}` +
          (type ? `&type=${type}` : ``) +
          (key ? `&name=${key}` : ``),
        { 
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setHubData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setHubData({ loading: false, data: [] });
        console.error("Hub: Error", err);
      });
  }, [page, limit, type, key]);

  useEffect(() => {
    getHub();
  }, [getHub]);

  const getHubOptions = useCallback(
    async (key) => {
      setHubOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/hub/search?page=0&limit=20` +
            (key ? `&name=${key}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setHubOptions({
            loading: false,
            list: res.data?.hub?.map((hub) => ({
              label: hub.name,
              value: hub.name,
            })),
          });
        })
        .catch((err) => {
          setHubOptions({ loading: false, list: [] });
          console.error("Hubs: Error", err);
        });
    },
    [type]
  );

  //
  const onDelete = async (id, val: any) => {
    setConfirmLoading(true);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/hub`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          deleted: !val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setConfirmLoading(undefined);
          if (res.statusCode === 200) {
            responseNotification("Status Changed Successfully", "success");
            getHub();
            setVisible(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    setType("JC_MART");
    form.resetFields();
  };

  useEffect(() => {
    if (visible) {
      setSelectedHub(undefined);
      setSelectedHubForEdit(undefined);
    }
  }, [selectedHub, selectedHubForEdit, visible]);

  useEffect(() => {
    setSelectedHub(undefined);
    setSelectedHubForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedHub(null);
    setSelectedHubForEdit(null);
    getHub();
  };

  const fetchRef = useRef(0);
  const debounceHubOptionsFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getHubOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getHubOptions]);

  return (
    <React.Fragment>
      <TopHeading total={hubData?.data?.totalElements} refetch={getHub} />
      <section className="search_area">
        <Form form={form} className="search_form">
          {/* <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              onSelect={(val) => setType(val.toString())}
              value={type}
              style={{ width: 250 }}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item> */}

          <Form.Item name="search">
            <AutoComplete
              style={{ width: 300 }}
              onSearch={debounceHubOptionsFetcher}
              onSelect={(val) => setKey(val.toString())}
              options={hubOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                hubOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={hubOptions.loading}
              />
            </AutoComplete>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Hub Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Created Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {hubData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {hubData?.data?.hubs?.length ? (
                    hubData?.data?.hubs?.map((hub: any, index: any) => (
                      <React.Fragment key={index}>
                        <Link to={`/hubs/${hub?.id}/details`}>
                          <div className="single-product-wrapper">
                            <div className="single-product major">
                              <Avatar
                                shape="circle"
                                size={45} 
                                src={getImgUrl(hub?.image)}
                                className="mr-3"
                              />
                              <span className="name">
                                {hub?.name?.toUpperCase()}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {hub?.type?.replace("_", " ")}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {moment(hub?.createdAt).format("lll")}
                              </span>
                            </div>

                            <div className="single-product">
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={!hub?.deleted}
                                onChange={(val, e) => {
                                  e.preventDefault();
                                  onDelete(hub?.id, val);
                                }}
                                loading={
                                  confirmLoading && hub?.id === confirmLoading
                                }
                              />
                            </div>

                            <div className="single-product">
                              <Link
                                to=""
                                className="btn btn-sm btn-warning mx-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedHubForEdit(hub);
                                }}
                              >
                                <EditOutlined />
                              </Link>
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Hubs" />
                  )}
                </div>
              </div>
            )}
          </div>

          {confirmLoading && <LoaderFull />}

          <Drawer
            title={"Edit Hub"}
            width={600}
            onClose={() => {
              setSelectedHub(null);
              setSelectedHubForEdit(null);
            }}
            visible={selectedHub || selectedHubForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedHubForEdit ? (
              <AddHub
                // hubId={selectedHubForEdit}
                onCloseMethod={onClose}
                visibleData={selectedHubForEdit}
              />
            ) : undefined}
          </Drawer>

          <PaginationTwo
            {...hubData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default HubsList;
